"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { useRef, useLayoutEffect } from 'react';

function useWindowEvent(type, listener) {
  const listenerRef = useRef(listener);
  listenerRef.current = listener;
  useLayoutEffect(() => {
    function handler(event) {
      listenerRef.current.call(window, event);
    }
    window.addEventListener(type, handler);
    return () => window.removeEventListener(type, handler);
  }, [type]);
}

export { useWindowEvent };
